import PropTypes from 'prop-types';
import style from '../ModalBoxWrapper.module.less';

function ModalBoxCloseBar(props) {
	if (!props.text) {
		return;
	}
	return (
		<div className={style.modalCloseBar}>
			{props.text}
			<i onClick={props.onClose} className="icon -icon-close-full" />
		</div>
	);
}

ModalBoxCloseBar.propTypes = {
	text: PropTypes.string,
	onClose: PropTypes.func,
};
ModalBoxCloseBar.defaultProps = {
	text: '',
	onClose: () => {},
};

export default ModalBoxCloseBar;
